import HackerRank from '../Images/HackerRank.jpg'
import Duolingo from '../Images/Duolingo.png'
import LinkedIn from '../Images/LinkedIn.jpg'
import openInNewTab from '../Images/openInNewTab.png'

export const CertificationsSection = () => {
    return (
        <div class="Section CertificationsSection" id="certifications">
            <div class="SectionTitle"><h2>Certifications ✅</h2></div>
            <div class="CardGrid CertificationsGrid">
                <CertificationCard title="Duolingo English Test" description="Score obtained: 145" date="Nov 2021" image={Duolingo} link="https://certs.duolingo.com/74fb436d52375a4fba8d4c55a656a48f"/>
                <CertificationCard title="HackerRank Problem Solving Certificate" description="" date="Oct 2020" image={HackerRank} link="https://www.hackerrank.com/certificates/4a17e028ad2c"/>
                <CertificationCard title="HackerRank Python Certificate" description="" date="Oct 2020" image={HackerRank} link="https://www.hackerrank.com/certificates/96afb53d3b57"/>
                <CertificationCard title="LinkedIn Skill Assessment" description="Passed LinkedIn's skill assessments for Swift, Git, CSS and HTML." date="2022" image={LinkedIn} link="https://www.linkedin.com/in/marius-genton-879092249/"/>
            </div>
            <p><br></br></p>
        </div>
    )
}

const CertificationCard = (props) => {
    return (
        <div class="Card CertificationCard">
            <img src={props.image} alt="icon"/>
            <div>
                <h3>{props.title}</h3>
                <h5>{props.date}</h5>
                <p>{props.description}</p>
            </div>
            <a href={props.link} class="SeeCertification">
                <img src={openInNewTab}/>
            </a>
        </div>
    )
}